module.exports = __webpack_public_path__ + "files/b141323272a5fc43ff0013b5c61c0542.png";